import { createURL } from '@sm/utils';

/**
 * Navigates to the given base URL and query.
 */
export default function navigateTo(url: string, params?: Record<string, string>): void {
  window.location.assign(createURL(url, params));
}
